// @ts-ignore
/* eslint-disable */
export * from './utils';
export * from './cookie';
export * from './user';
export * from './role';
export * from './chart';
export * from './option';
export * from './event';
export * from './bank';
export * from './strategy';
export * from './device';
export * from './log';
export * from './maintenance';
export * from './patrol';
export * from './permission';

export const isLocalhost =
  location.hostname === 'localhost' || location.hostname.includes('127.0.0.1');
export const WEB_TARGET = isLocalhost ? process.env.WEB_URL || 'https://10.0.2.6' : '';
export const apiProxy = (process.env.BACKEND_URL || '') + '/xfx-api/center/v1';

export const wsProxy =
  (process.env.BACKEND_WS_URL ||
    `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}`) + '/web';

export const apiUrl = {
  logout: '/authorize/logout',
  login: '/authorize/login',
  sendSMS: '/authorize/send-sms',
  verifySMS: '/authorize/verify-sms',
  userinfo: '/authorize/info',
  userinfoName: '/user/info',
  userinfoPwd: '/user/passwd',
  users: '/user/_inquiry',
  userUpdate: (id?: string | number) => (id ? `/user/${id}` : '/user'),
  userReset: (id: string | number, type: number) =>
    `/user/${id}/passwd/reset?id=${id}&type=${type}`,
  roles: '/role/_query',
  banks: '/bank/_query',
  bank: (id?: string | number) => (id ? `/bank/${id}` : '/bank'),
  bankTree: '/bank/tree',
  branches: '/sub-branch/_query',
  branch: (id?: string | number) => (id ? `/sub-branch/${id}` : '/sub-branch'),
  permissions: '/menu/_permission',
  logs: '/log',
  logTypes: '/log/_query_types',
  logUsers: '/log/_query_users',
  eventDataHandle: '/security-event/_statistic/solute-type',
  eventDataStatus: '/security-event/_statistic/accuracy',
  eventTypes: '/event_type/_all',
  sceneDefaultEventTypes: '/functions/_default_conf',
  eventTypesById: (id: string) => `/event_type/${id}`,
  // branchOrgs: '/depts/branchOrg',
  // branchOrgsWithPer: '/depts/branchOrgWithPermission',
  events: '/management-event/_query',
  indexEvents: '/security-event/_query',
  voiceEvents: '/lm-voice-event/_query',
  eventOrgs: '/management-event/_statistic',
  tnEvents: '/tn-event/_query',
  tnSampleExport: '/tn-event/_excel/template',
  tnEventUpload: '/tn-event/_excel/import',
  eventExport: '/management-event/_export',
  indexEventExport: '/security-event/_export',
  eventBatch: '/management-event/_batch',
  indexEventBatch: '/security-event/_batch',
  eventDetail: (id: string) => `/management-event/${id}`,
  indexEventDetail: (id: string) => `/security-event/${id}`,
  voiceEventDetail: (id: string) => `/lm-voice-event/${id}`,
  tnEventDetail: (id: string | number) => `/tn-event/${id}`,
  tnEventCancel: (id: string | number) => (id ? `/tn-event/_cancel/${id}` : '/tn-event/_cancel'),
  tnEventHandle: (id: string | number) => (id ? `/tn-event/_handle/${id}` : '/tn-event/_handle'),
  depts: '/department/_inquiry',
  dept: (id?: string | number) => (id ? `/department/${id}` : '/department'),
  deptUpload: '/department/_excel/import',
  deptExport: '/department/_excel/export',
  deptSampleExport: '/department/_excel/template',
  deptCameras: '/equipment-cam/_inquiry/list',
  // deptUsers: '/dept/users',
  // cameraByPer: '/dept/camerasByPermission',
  locations: '/direction',
  eventRanks: (type: string | number) => `/management-event/_rank/${type}`,
  eventDownloadUrl: (id: string) => `/management-event/_download_url/${id}`,
  orgPing: (id: string) => `/nodes/org/${id}/ping`,
  playbackUrl: (id: string) => `/stream-flv/_history/${id}`,
  eventVideo: (id: string) => `/stream-flv/${id}`,
  holidayPlans: '/shift-adjustment/_inquiry',
  holidayPlan: (id?: string | number) => (id ? `/shift-adjustment/${id}` : '/shift-adjustment'),
  works: '/work/config/group',
  work: (id?: string | number) => (id ? `/work/config/${id}` : '/work/config'),
  alarmConfigs: '/functions/_alarm_config',
  alarmEventType: (id?: string | number) =>
    id ? `/functions/_modify_event_type/${id}` : '/functions/_modify_event_type',
  resetAlarmEventType: (functionId?: string | number, eventTypeId?: string | number) =>
    `/functions/_reset_event_type/${functionId}/${eventTypeId}`,
  alarmStrategies: (functionId?: string | number, eventTypeId?: string | number) =>
    `/scene/orgConfig/${functionId}/${eventTypeId}/list`,
  alarmStrategyPolicy: (functionId?: string | number, eventTypeId?: string | number) =>
    `/scene/orgConfig/${functionId}/${eventTypeId}/customPolicy`,
  alarmStrategyEnable: (
    functionId?: string | number,
    eventTypeId?: string | number,
    enable?: string | number,
  ) => `/scene/orgConfig/${functionId}/${eventTypeId}/enable/${enable}`,
  nvr: (id?: string | number) => (id ? `/nvr/${id}` : '/nvr'),
  nvrManufactures: '/nvr/manufactures',
  nvrRefresh: (id: string | number) => `/nvr/${id}/fresh`,
  nvrSampleExport: '/nvr/template/download',
  nvrUpload: '/nvr/import',
  cameras: '/equipment-cam/_inquiry',
  camera: (id?: string | number) => (id ? `/equipment-cam/${id}` : '/equipment-cam'),
  cameraActivate: (id?: string | number) =>
    id ? `/equipment-cam/_activate/${id}` : '/equipment-cam/_batch/activate',
  cameraSnapshot: (id?: string | number) =>
    id ? `/equipment-cam/_snapshot/${id}` : '/equipment-cam/_snapshot',
  cameraDrawbox: (id?: string | number) =>
    id ? `/equipment-cam/_batch/_drawbox/${id}` : '/equipment-cam/_batch/_drawbox',
  cameraDrawboxMulti: (id?: string | number) =>
    id ? `/equipment-cam/_batch/_drawbox/multi/${id}` : '/equipment-cam/_batch/_drawbox/multi',
  cameraDrawboxUnified: (id?: string | number) =>
    id ? `/equipment-cam/_batch/_drawbox/unified/${id}` : '/equipment-cam/_batch/_drawbox/unified',
  cameraDelete: '/equipment-cam/_batch/delete',
  cameraUpload: '/equipment-cam/_excel/import',
  cameraExport: '/equipment-cam/_excel/export',
  cameraSampleExport: '/equipment-cam/_excel/template',
  cameraGroups: '/group/_query',
  cameraEvents: (id?: string | number) => (id ? `/functions/${id}` : '/functions'),
  scenes: '/functions/_all',
  aiServers: '/edge-server/_inquiry',
  node: (id?: string | number) => (id ? `/edge-server/${id}` : '/edge-server'),
  nodeAuthorize: (id?: string | number) =>
    id ? `/edge-server/authorize/${id}` : '/edge-server/authorize',
  nodeUnAuthorize: (id?: string | number) =>
    id ? `/edge-server/deauthorize/${id}` : '/edge-server/deauthorize',
  nodeReset: (id?: string | number) => (id ? `/nodes/reset/${id}` : '/nodes/reset'),
  nodeStatus: (id?: string | number) =>
    id ? `/edge-server/_status_resource_info/${id}` : '/edge-server/_status_resource_info',
  nodeCache: (id?: string | number) =>
    id ? `/nodes/cache/event_types/${id}` : '/nodes/cache/event_types/',
  nodeConfig: (id?: string | number) => (id ? `/nodes/config/${id}` : '/nodes/config'),
  serverConfigs: '/config/_query/3',
  serverConfig: (id?: string | number, type = 3) =>
    id ? `/config/_modify/${type}/${id}` : `/config/_modify/${type}`,
  cameraTroubles: '/fault-device/_camera',
  shootTroubles: '/fault-edge/_query/list',
  troubleTypes: '/fault-edge/_types',
  troubleUsers: '/fault-edge/_users',
  troubleNodes: '/edge-server/_inquiry/list',
  troubleExport: '/fault-edge/_export',
  troubleBatch: '/fault-edge/_batch',
  trouble: (id?: string | number) => (id ? `/fault-edge/${id}` : '/fault'),
  troublePing: (id?: string | number) =>
    id ? `/device/fault-edge/${id}/ping` : '/device/fault-edge/ping',
  faceLib: '/face-library/_inquiry',
  faceMember: (id?: string | number) => (id ? `/face-library/${id}` : '/face-library'),
  facePhoto: (id: string | number, photoId?: string | number) =>
    photoId ? `/face-library/${id}/_photos/${photoId}` : `/face-library/${id}/_photos`,
  faceRetrievals: '/face-retrieval-record/by-camera',
  license: '/license/v1/info',
  licenseUpload: '/license/v1/upload',
  userPermissionsAll: '/bank/_tree',
  userPermissions: (id?: string | number) =>
    id ? `/user_data_permission/${id}` : '/user_data_permission',
  userPermissionsQuery: (id?: string | number) =>
    id ? `/user_data_permission/_query/${id}` : '/user_data_permission/_query',
  flowStatistics: '/branch-face-flow/statistics',
  regionStatistics: '/regional-thermal/statistics',
  latestRegionStatistics: '/regional-thermal/latest',
  mockEvent: (cameraId?: string | number, eventId?: string | number) =>
    cameraId && eventId ? `/mock/v1/event/${cameraId}/${eventId}` : '/mock/v1/event',
  patrolBrief: '/patrol-task/progress/brief',
  patrolPoints: '/patrol-point/_query',
  patrolPoint: (id?: string | number) => (id ? `/patrol-point/${id}` : '/patrol-point'),
  patrolPointDelete: '/patrol-point/_batch/delete',
  patrolPointActivate: '/patrol-point/_batch/activate',
  patrolTasks: '/patrol-task/_query',
  patrolTask: (id?: string | number) => (id ? `/patrol-task/${id}` : '/patrol-task'),
  patrolRecords: '/patrol-task/progress/_inquiry',
  patrolRemark: (id?: string | number) =>
    id ? `/patrol-task/progress/${id}/handle-remark` : '/patrol-task/progress/handle-remark',
  securityEventReport: '/security-event/_report',
  securityEventOutlets: '/security-event/_report/outlets',
  managementEventReport: '/management-event/_report',
  voiceEventReport: '/lm-voice-event/_report',
  voiceCategories: '/lm-voice-event/_report/categories',
};
